import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { store } from "Redux/store";
import { registerChunkReload } from "Utils/chunkReload";

import Initializer from "./hoc/Initializer";

// Apply the persisted theme before first paint to avoid a light flash (FOUC).
// Strip quotes so a legacy JSON-stringified value ("dark") still resolves correctly.
const persistedTheme = (window.localStorage?.getItem("theme") || "").replace(/"/g, "");
if (persistedTheme) {
  document.documentElement.setAttribute("data-theme", persistedTheme);
}


registerChunkReload();

ReactDOM.render(
  <Provider store={store}>
    <Initializer />
  </Provider>,
  document.getElementById("root") || document.createElement("div") // for testing purposes
);
